<template>
    <v-btn
        @click="copy"
        color="primary"
        small
        :disabled="selectedQuestionsForCopying.length == 0"
    >
        <v-icon left>mdi-content-copy</v-icon>
        copy terpilih
    </v-btn>
</template>

<script>
export default {
    props: {
        selectedQuestionsForCopying: {
            type: Array,
            required: true,
        },
    },

    methods: {
        copy() {
            navigator.clipboard.writeText(
                this.selectedQuestionsForCopying.join(',')
            )
        },
    },

    created() {
        this.$emit('input', [])
    },
}
</script>
